import {
  // BY_CLIENTS_PATH,
  CREATED_DECLARANTS_PATH,
  DELETED_DECLARANTS_PATH,
  DEPARTMENTS_DATA_PATH,
  HOMEPAGE_PATH,
  CMR_PATH,
  SIGMA_PATH,
  LOGISTIC_PATH,
  CONTRACTS_PATH,
  FLEET_EXPENSES_PATH,
} from "../../../constants/auth";
import { HEADER } from "../../../constants/translates";
import {
  // BY_CLIENTS,
  CREATED_KEY,
  DECLARANT_KEY,
  DELETED_KEY,
  DEPARTMENTS_DATA_KEY,
  CMR_KEY,
  SIGMA_KEY,
  LOGISTIC_KEY,
  CONTRACTS_KEY,
  FLEET_EXPENSES_KEY,
} from "../../../constants/navigation";
import {
  // ACCESS_TO_BY_CLIENTS,
  ACCESS_TO_DEPARTMENTS_DATA,
  DELETE_DECLARANT,
  PermissionType,
  RoleType,
  HAS_ACCESS_TO_CMR,
  ACCESS_TO_FLEET_EXPENSES,
  ROLE_DECLARANT,
  ROLE_ADMIN,
  ROLE_EMPLOYEE,
} from "../../../constants/authorize";

export interface Item {
  key: string;
  title: string;
  path: string;
  authorizeByPermission?: PermissionType;
  authorizeByRole?: RoleType;
}

const navigation: Item[] = [
  {
    key: DECLARANT_KEY,
    path: HOMEPAGE_PATH,
    title: HEADER.declarant,
  },
  {
    key: SIGMA_KEY,
    path: SIGMA_PATH,
    title: HEADER.sigma,
  },
  {
    key: CREATED_KEY,
    path: CREATED_DECLARANTS_PATH,
    title: HEADER.created,
  },
  {
    key: DEPARTMENTS_DATA_KEY,
    path: DEPARTMENTS_DATA_PATH,
    title: HEADER.departmentsData,
    authorizeByPermission: [ACCESS_TO_DEPARTMENTS_DATA],
  },
  // {
  //   key: BY_CLIENTS,
  //   path: BY_CLIENTS_PATH,
  //   title: HEADER.byClients,
  //   authorizeByPermission: [ACCESS_TO_BY_CLIENTS],
  // },
  // {
  //   key: CASHBOX_KEY,
  //   path: CASHBOX_PATH,
  //   title: HEADER.cashbox,
  //   authorizeByPermission: [WORK_WITH_CASH],
  // },
  {
    key: CMR_KEY,
    path: CMR_PATH,
    title: HEADER.cmr,
    authorizeByPermission: [HAS_ACCESS_TO_CMR],
  },
  {
    key: LOGISTIC_KEY,
    path: LOGISTIC_PATH,
    title: HEADER.logistic,
  },
  {
    key: CONTRACTS_KEY,
    path: CONTRACTS_PATH,
    title: HEADER.contracts,
    authorizeByRole: [ROLE_ADMIN, ROLE_EMPLOYEE, ROLE_DECLARANT],
  },
  {
    key: FLEET_EXPENSES_KEY,
    path: FLEET_EXPENSES_PATH,
    title: HEADER.fleetExpenses,
    authorizeByPermission: [ACCESS_TO_FLEET_EXPENSES],
  },
  {
    key: DELETED_KEY,
    path: DELETED_DECLARANTS_PATH,
    title: HEADER.deleted,
    authorizeByPermission: [DELETE_DECLARANT],
  },
];

export default navigation;
